<template>
	<div :id="id" class="app-modal modal fade" :class="customClass" tabindex="-1" role="dialog" :aria-labelledby="`${id}-label`" aria-hidden="true" data-bs-backdrop="static">
		<div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div v-if="showHeader" class="modal-header">
					<div class="container">
						<div class="row g-3 justify-content-center">
							<div class="col-12 col-md-6">
								<h1 class="modal-title" :id="`${id}-label`">
									<slot name="icon"></slot>
									<slot name="title"></slot>
								</h1>
							</div>
						</div>
					</div>

					<!--					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>-->
				</div>
				<div class="modal-body">
					<slot></slot>
				</div>
				<div v-if="showFooter" id="modal-footer-section" class="modal-footer flex-column">
					<div class="container">
						<div class="row g-3 justify-content-center">
							<div class="col-6 col-md-3">
								<div class="d-grid">
									<DismissButton :on-click="onClickClose" :is-modal="true" :content-btn-text="textBtnClose" />
								</div>
							</div>
							<div class="col-6 col-md-3">
								<div class="d-grid">
									<slot name="footer"></slot>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DismissButton from '@/components/shared/DismissButton.vue'

export default {
	name: 'ModalWrapperXLBodyScroll',
	components: { DismissButton },
	props: {
		id: {
			type: String,
			required: true
		},
		textBtnClose: {
			type: String
		},
		onClickClose: {
			type: Function,
			required: false,
			default: () => {
			}
		},
		showHeader: {
			type: Boolean,
			required: false,
			default: true
		},
		showFooter: {
			type: Boolean,
			required: false,
			default: true
		},
		customClass: {
			type: String,
			required: false,
			default: ''
		}
	}
}
</script>

<style scoped></style>
